export default "__VITE_ASSET__1456e671__"